<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox></navBox>
			<!--导航-->
			<!--banner-->
			<div class="banner_box">
				<img :src="type == 'social.html' ? require('@/assets/img_public/job/banner01_h5.webp') : require('@/assets/img_public/job/banner02_h5.webp')"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				/>
				<div class="msg_box"
					data-aos="fade-UP"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="tit">{{ type == 'social.html' ? '社会招聘' : '校园招聘' }}</div>
					<div class="txt">{{ type == 'social.html' ? 'SOCIAL RECRUITMENT' : 'CAMPUS RECRUITING' }}</div>
					<div class="h5_public_btn" @click="checkType"><van-icon name="exchange" size="16px" class="btn_icon" /> {{ type == 'social.html' ? '校园招聘' : '社会招聘' }}</div>
				</div>
			</div>
			<!--banner-->
			<!--块1-->
			<div class="block_1">
				<!--轮播-->
				<van-swipe class="swipe_box" :autoplay="3000" show-indicators :stop-propagation="false" indicator-color="#A50073"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<van-swipe-item v-for="(value, index) in bannerList" :key="index">
						<div class="swiper_el">
							<img class="bg" :src="value.imgUrl" @click="goCulture(index)" />
						</div>
					</van-swipe-item>
				</van-swipe>
				<!--轮播-->
				<div class="search_box"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<van-icon name="search" size="20px" style="top: -1px;" />
					<input v-model="inputVal" placeholder="请输入搜索关键词" />
					<div class="tit" @click="searchClick">搜索</div>
				</div>
				<div class="search_list">
					<div class="tit_box">
						<div class="left">职位筛选</div>
						<div class="right" @click="selectClear">重置</div>
					</div>
					<div v-if="addressList.length > 0" class="search_el"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="tit">工作地点</div>
						<div class="search_el_list">
							<div :class="addressId == '' ? 'actived' : ''" @click="allClick(1)">全部</div>
							<div v-for="(value, index) in addressList" :key="index" :class="addressId == value.id ? 'actived' : ''" @click="selectCheck(1, value)">{{ value.title }}</div>
						</div>
					</div>
					<div v-if="postList.length > 0" class="search_el"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="tit">职能类型</div>
						<div class="search_el_list">
							<div :class="postId == '' ? 'actived' : ''" @click="allClick(2)">全部</div>
							<div v-for="(value, index) in postList" :key="index" :class="postId == value.id ? 'actived' : ''" @click="selectCheck(2, value)">{{ value.title }}</div>
						</div>
					</div>
					<div v-if="leixingList.length > 0" class="search_el"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="tit">职能性质</div>
						<div class="search_el_list">
							<div :class="leixingId == '' ? 'actived' : ''" @click="allClick(3)">全部</div>
							<div v-for="(value, index) in leixingList" :key="index" :class="leixingId == value.id ? 'actived' : ''" @click="selectCheck(3, value)">{{ value.title }}</div>
						</div>
					</div>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div v-if="listData.length > 0" class="block_2">
				<div class="title">全部职位</div>
				<div class="list_box">
					<div
						v-for="(value, index) in listData"
						:key="index"
						class="list_el"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
						@click="goInfo(value)"
					>
						<div class="tit">{{ value.title }}</div>
						<div class="txt1">
							<van-icon name="todo-list-o" size="16px" color="#666666" style="top: 3px;" /> {{ value.post_name }} | {{ value.address_name }}
						</div>
						<div class="txt2">
							<van-icon name="clock-o" size="14px" color="#999999" style="top: 3px;" /> 发布时间：<span>{{ value.fabu_time }}</span>
						</div>
					</div>
				</div>
				<div class="page_box">
					<el-pagination
						:small="false"
						background
						layout="prev, pager, next"
						:total="total"
						:page-size="10"
						:pager-count="5"
						@current-change="pageChange"
					>
					</el-pagination>
				</div>
			</div>
			<div v-else>
				<van-empty image="search" description="暂无数据~" />
			</div>
			<!--块2-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/h5/nav.vue'  //导航组件
import footerBox from '@/component/h5/footer.vue'  //版权组件
import { jobSelectList, jobList } from '@/api/public';  //筛选列表
export default {
	components:{
		navBox,
		footerBox
	},
	data() {
		return {
			isLoading: true,  //界面loading
			bannerList: [
				{ imgUrl: require('@/assets/img_public/job/block01_h5.webp') },
				{ imgUrl: require('@/assets/img_public/job/block02_h5.webp') }
			],
			type: 'social.html',
			addressList: [],
			leixingList: [],
			postList: [],
			addressId: '',
			leixingId: '',
			postId: '',
			inputVal: '',
			listData: [],
			page: 1,
			total: 0,
			listLoading: true,
		}
	},
	created(){
		let that = this;
		if(that.$route.params.jobId) {
			that.type = that.$route.params.jobId;
			//请求筛选数据
			that.getSelectList();
			//获取职位列表
			that.getList();
		}
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//点击进入详情
		goInfo(value) {
			let that = this;
			that.$router.push({ name: 'JobInfo', params: { type: that.type, jobInfoId: value.id + '.html' } });
		},
		//点击搜索
		searchClick() {
			let that = this;
			that.page = 1;
			that.getList();
		},
		//分页点击
		pageChange(val) {
			let that = this;
			that.page = val;
			that.getList();
		},
		//请求列表
		getList() {
			let that = this;
			// that.listLoading = true;
			that.$toast.loading({ message: '', forbidClick: true, duration: 0 });
			jobList({
				keyword: that.inputVal,
				address_id: that.addressId,
				post_id: that.postId,
				leixing_id: that.leixingId,
				leixing: that.type == 'social.html' ? 1 : 2,
				page: that.page,
				page_size: 10,
				language: sessionStorage.getItem('lang')
			}).then(res => {
				that.listData = res.data.data;
				that.total = res.data.total;
				//that.listLoading = false;
				that.$toast.clear();
			});
		},
		//清空筛选
		selectClear() {
			let that = this;
			that.addressId = '';
			that.postId = '';
			that.leixingId = '';
			that.inputVal = '';
			that.page = 1;
			that.getList();
		},
		//点击全部
		allClick(type) {
			let that = this;
			switch(type) {
				case 1:
					that.addressId = '';
				break;
				case 2:
					that.postId = '';
				break;
				case 3:
					that.leixingId = '';
				break;
			}
			that.page = 1;
			that.getList();
		},
		//切换筛选项
		selectCheck(type, value) {
			let that = this;
			switch(type) {
				case 1:
					that.addressId = value.id;
				break;
				case 2:
					that.postId = value.id;
				break;
				case 3:
					that.leixingId = value.id;
				break;
			}
			that.page = 1;
			that.getList();
		},
		//请求筛选列表
		getSelectList() {
			let that = this;
			jobSelectList({ language: sessionStorage.getItem('lang') }).then(res => {
				that.addressList = res.data.address_list;
				that.leixingList = res.data.leixing_list;
				that.postList = res.data.post_list;
			});
		},
		//跳转企业文化
		goCulture(index) {
			if(index == 1) {
				this.$router.push({ path: '/about/culture.html' });
			}
		},
		//切换招聘类型
		checkType() {
			let that = this;
			if(that.type == 'social.html') {
				that.$router.push({ name: 'JobList', params: { jobId: 'school.html', } });
				window.location.reload();
			}else if(that.type == 'school.html') {
				that.$router.push({ name: 'JobList', params: { jobId: 'social.html', } });
				window.location.reload();
			}
		}
	}
}
</script>

<style lang="less" scoped>
.main_box{
	//块2
	.block_2{
		padding: 20px;
		background-color: #F7F6F9;
		.page_box{
			padding: 20px 0 30px 0;
			text-align: center;
		}
		.list_box{
			.list_el{
				margin-bottom: 12px;
				padding: 20px 16px;
				background-color: #ffffff;
				border-radius: 8px;
				.tit{
					padding-bottom: 6px;
					font-size: 18px;
					border-bottom: 1px solid #F7F6F9;
				}
				.txt1{
					padding: 12px 0 4px 0;
				}
				.txt2{
					color: #999999;
					span{
						font-size: 15px;
					}
				}
			}
		}
		.title{
			padding-bottom: 20px;
			font-size: 16px;
		}
	}
	//块1
	.block_1{
		padding: 0px 20px 10px 20px;
		//轮播
		.swipe_box{
			position: relative;
			top: -25px;
			.swiper_el{
				img.bg{
					width: 100%;
				}
			}
		}
		.search_list{
			.search_el{
				padding-bottom: 10px;
				.search_el_list{
					overflow: hidden;
					div{
						display: inline-block;
						margin: 5px 10px 5px 0px;
						padding: 6px 8px;
						border-radius: 8px;
						cursor: pointer;
						color: #666666;
					}
					div.actived{
						background-color: #F7F6F9;
						color: #A50073;
					}
				}
				.tit{
					padding-bottom: 10px;
					font-weight: bold;
				}
			}
			.tit_box{
				display: flex;
				align-items: center;
				padding: 30px 0 20px 0;
				.left{
					flex: 1;
					font-size: 20px;
					font-weight: bold;
				}
				.right{
					flex: 1;
					text-align: right;
				}
			}
		}
		.search_box{
			position: relative;
			margin: 0;
			padding: 0 24px 0 16px;
			background-color: #ffffff;
			border: 1px solid #A50073;
			border-radius: 8px;
			display: flex;
			align-items: center;
			input{
				flex: 1;
				height: 38px;
				color: #A50073;
				border: none;
				padding: 0px 5px;
				user-select: none;
			}
			.tit{
				width: auto;
				font-size: 16px;
				line-height: 1;
				color: #A50073;
			}
		}
	}
	//轮播
	.banner_box{
		position: relative;
		.msg_box{
			width: 100%;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			text-align: center;
			.h5_public_btn{
				margin-top: 10px;
				color: #ffffff;
				border: 1px solid #ffffff;
			}
			.txt{
				color: #ffffff;
			}
			.tit{
				font-size: 30px;
				font-weight: bold;
				color: #ffffff;
			}
		}
		img{
			width: 100%;
		}
	}
}
</style>
<style scoped>
/*分页*/
>>> .page_box .el-pagination {
  max-width: 100%; /* 最大宽度为屏幕宽度 */
}

>>> .page_box .el-pager li:hover{
	color: #A50073 !important;
}
>>> .page_box .el-pagination.is-background .el-pager li:not(.disabled).active{
	background-color: #A50073 !important;
}
>>> .page_box .el-pagination.is-background .el-pager li:not(.disabled).active:hover{
	color: #ffffff !important;
}
</style>